import { useQuery } from "@tanstack/react-query";

import { getFootprintingDairyFeedAdditive } from "services";

import { FOOTPRINTING_DAIRY_FEED_ADDITIVE } from "consts";

export const useGetFootprintingDairyFeedAdditive = (primaryDataId?: string) =>
  useQuery({
    queryKey: [FOOTPRINTING_DAIRY_FEED_ADDITIVE, primaryDataId],
    queryFn: () => getFootprintingDairyFeedAdditive(primaryDataId ?? ""),
    enabled: !!primaryDataId,
    gcTime: 0,
  });
